import { PixelmateBanner} from "./modules/PixelmateBanner";

// Banner initialisieren sobald das DOM bereit ist
function initializeBanner() {
    if (typeof window.pixelmateConfig !== 'undefined' && !window.pixelmateBanner) {
        window.pixelmateBanner = new PixelmateBanner();
    }
}

// Falls DOM bereits geladen ist, sofort initialisieren
if (document.readyState === 'loading') {
    // DOM lädt noch, Event Listener registrieren
    document.addEventListener('DOMContentLoaded', initializeBanner);
} else {
    // DOM bereits geladen, sofort initialisieren
    initializeBanner();
}